import { createRouter, createWebHistory } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/index';
import { setCookie, getCookie } from '~utils/cookies';
import Api from '~utils/Api';
import { ConstantParams } from '~store/types';

// eslint-disable-next-line import/no-cycle
import routes from './routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = useAuthStore();
  const url = window.location;
  await store.getImei();
  if (!from.name) {
    const regex = /\?code=(.*)/gm;
    const guCode = url.href.match(regex);
    if (guCode && guCode.length && !store.isAuth) {
      try {
        const res = await fetch(`https://esia.medsafe.tech/r/${getCookie('medsafe-tech-hash')}/${store.getIMEI}${guCode[0]}`);
        if (res.status >= 200 && res.status < 300) {
          const data = await res.json();
          if (data && data.length) {
            if (data[0].TK) {
              setCookie('id_login', `${data[0].id_login}`, { secure: true, expires: 1 });
              setCookie('TK', data[0].TK, { secure: true, expires: 1 });
              const constantParams: ConstantParams = {
                IMEI: store.getIMEI,
                Name_app: 'WEB_managers',
                TK: data[0].TK,
                id_login: data[0].id_login,
              };
              useMainStore().setConstantParams(constantParams);
              store.isAuth = true;
              next({ path: '/app-list' });
            }
          } else {
            next({ path: '/login' });
            useMainStore().showMessage('Извините, мы Вас не узнали...');
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
  const isAuth = store.getIsAuth;
  // if (!isAuth) {
  await useAuthStore().autenticate();
  // }
  const toCompare = store.isAuth;
  // || (getCookie('id_login') && getCookie('TK'));
  if (!toCompare && to.path !== '/login') {
    next({ path: '/login' });
  } else if (toCompare && to.path === '/login') next({ path: '/app-list' });
  else next();
});

export default router;
